import { jsx as _jsx } from "react/jsx-runtime";
import { twMerge } from "tailwind-merge";
export var ChampionIcon = function (_a) {
    var champion = _a.champion, _b = _a.className, className = _b === void 0 ? "" : _b, _c = _a.variant, variant = _c === void 0 ? "normal" : _c, alt = _a.alt, onClick = _a.onClick;
    var getImageSrc = function () {
        try {
            var imageName = variant === "vertical" ? "".concat(champion, "_Vertical") : champion;
            return require("../../assets/images/champions/".concat(imageName, ".PNG"));
        }
        catch (error) {
            // Fallback to default image if champion image not found
            return require("../../assets/images/champions/default.PNG");
        }
    };
    return (_jsx("img", { src: getImageSrc(), alt: alt || "".concat(champion, " icon"), className: twMerge("h-4 w-4 rounded-full", className), onClick: onClick, style: { cursor: onClick ? "pointer" : "default" } }));
};
